import { SVGProps } from 'react'

export const Logout = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3H11.8473V4.47455H4.47455V19.2201H11.8473V20.6946H3V3ZM15.5337 6.38099L21 11.8473L15.5337 17.3136L14.491 16.271L18.1774 12.5846H8.16093V11.11H18.1774L14.491 7.42365L15.5337 6.38099Z"
      fill="currentColor"
    />
  </svg>
)

